import pcAdver from "mptcfe-pc-adver"
/**
 * @description 新增brightcom广告
 * @param {*} data
 * @param {*} el
 * @param {*} spmCode
 */
const brightcomAd = function (opt) {
    var data = opt && opt.data
    var el = opt && opt.el
    var spmCode = opt && opt.spmCode
    var resourceId = opt && opt.resourceId
    new pcAdver.AdGenerator({
        data: data,
        location: `${spmCode}.1`,
        resourceId: resourceId,
        success: function(adDom){
            adDom[0] && el.append(adDom[0])
            typeof opt.success === 'function' && opt.success()
        }
    })
}

export default brightcomAd